import { render, staticRenderFns } from "./permitTree.vue?vue&type=template&id=43451440"
import script from "./permitTree.vue?vue&type=script&lang=js"
export * from "./permitTree.vue?vue&type=script&lang=js"
import style0 from "./permitTree.vue?vue&type=style&index=0&id=43451440&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports